// this reducer is used to store the top shared photos on the prizes / community page

import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  photos: [],
};

const communityPhotoSlice = createSlice({
  name: 'communityPhotos',
  initialState,
  reducers: {
    setCommunityPhotos(state, {payload: photos}) {
      state.photos = photos;
    },
  },
});

export const {setCommunityPhotos} = communityPhotoSlice.actions;

export default communityPhotoSlice.reducer;
